export default function formatarCNPJ(input) {


    if (input == null) {
        return input
    }

    if (input.includes("*")) {
        return input
    }
    let cnpj = input.replace(/[^a-zA-Z0-9]/g, '');
    cnpj = cnpj.toUpperCase();

    if (cnpj.length > 14) {
        cnpj = cnpj.slice(0, 14);
    }

    if (cnpj.length <= 2) {
        cnpj = cnpj.replace(/([a-zA-Z0-9]{0,2})/, '$1');
    } else if (cnpj.length <= 5) {
        cnpj = cnpj.replace(/([a-zA-Z0-9]{0,2})([a-zA-Z0-9]{0,3})/, '$1.$2');
    } else if (cnpj.length <= 8) {
        cnpj = cnpj.replace(/([a-zA-Z0-9]{0,2})([a-zA-Z0-9]{0,3})([a-zA-Z0-9]{0,3})/, '$1.$2.$3');
    } else if (cnpj.length <= 12) {
        cnpj = cnpj.replace(/([a-zA-Z0-9]{0,2})([a-zA-Z0-9]{0,3})([a-zA-Z0-9]{0,3})([a-zA-Z0-9]{0,4})/, '$1.$2.$3/$4');
    } else {
        cnpj = cnpj.replace(/([a-zA-Z0-9]{0,2})([a-zA-Z0-9]{0,3})([a-zA-Z0-9]{0,3})([a-zA-Z0-9]{0,4})(\d{0,2}).*/, '$1.$2.$3/$4-$5');
    }

    return cnpj
}
